import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Pre-footer mega-CTA. Lime band visible on every page (excluding home).
 */
const BigCTA = ({
  text = "Pronto a costruire impatto?",
  href = "/contatti",
  testId = "big-cta",
}) => {
  return (
    <section
      className="bg-lime text-dodgers py-12 md:py-16"
      data-testid={testId}
    >
      <div className="container-os">
        <Link
          to={href}
          className="group flex items-center justify-between gap-6 flex-wrap"
          data-hover="true"
        >
          <span className="font-display text-3xl md:text-6xl leading-none">
            {text}
          </span>
          <span className="inline-flex items-center gap-3 font-condensed uppercase tracking-widest text-base md:text-lg">
            Parliamone
            <ArrowRight
              size={28}
              className="transition-transform group-hover:translate-x-2"
            />
          </span>
        </Link>
      </div>
    </section>
  );
};

export default BigCTA;
